import client from './client';
import type { Product, CreateProductRequest, CreateVariantRequest, ProductVariant } from '@/types/api';

export const productsApi = {
  getAll: async (): Promise<Product[]> => {
    const response = await client.get<Product[]>('/products');
    return response.data;
  },

  getById: async (id: string): Promise<Product> => {
    const response = await client.get<Product>(`/products/${id}`);
    return response.data;
  },

  getBySku: async (sku: string): Promise<Product> => {
    const response = await client.get<Product>(`/products/sku/${sku}`);
    return response.data;
  },

  search: async (query: string): Promise<Product[]> => {
    const response = await client.get<Product[]>('/products/search', { params: { query } });
    return response.data;
  },

  create: async (data: CreateProductRequest): Promise<Product> => {
    const response = await client.post<Product>('/products', data);
    return response.data;
  },

  update: async (id: string, data: CreateProductRequest): Promise<Product> => {
    const response = await client.put<Product>(`/products/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await client.delete(`/products/${id}`);
  },

  addVariant: async (productId: string, data: CreateVariantRequest): Promise<ProductVariant> => {
    const response = await client.post<ProductVariant>(`/products/${productId}/variants`, data);
    return response.data;
  },

  updateVariant: async (variantId: string, data: Partial<CreateVariantRequest>): Promise<ProductVariant> => {
    const response = await client.put<ProductVariant>(`/products/variants/${variantId}`, data);
    return response.data;
  },

  deleteVariant: async (variantId: string): Promise<void> => {
    await client.delete(`/products/variants/${variantId}`);
  },

  getQrCode: (variantId: string): string => {
    return `${client.defaults.baseURL}/products/variants/${variantId}/qr`;
  },
};
